module.exports = __webpack_public_path__ + "static/resume-12920d710678e322b60f8d0201d4163c.pdf";